<template src="./detail.html"></template>

<script>
import Vue from 'vue'
import isEmpty from 'lodash/isEmpty'
import optionData from '@/optionData/data'
import _ from 'lodash'
import flatten from 'flat'
import {ko} from 'vuejs-datepicker/dist/locale'
import moment from 'moment'
import { format } from 'date-fns'
import agTableComp from '@/optionData/agTableComp'
export const BtnSelect = Vue.extend({
  name : 'btnSelect',
  template: `
      <vs-button class="btnSmall" @click="btnClickedHandler()" color="success" type="filled">선택</vs-button>
    `,
  data(){
    return{
      title : ''
    }
  },
  created(){
    this.title = this.params.colDef.headerName? this.params.colDef.headerName : null
  },
  methods: {
    btnClickedHandler() {
      this.params.clicked(this.params.data);
    }
  },
});
export default {
    name: "albumRegistration",
    data() {
      return {
        contractList : [],
        selectContract : [],
        description : null,
        keywordOption :[
            {value: 'email', label:'Email ID'},
            {value: '_name', label:'권리자명'},
            {value: 'name', label:'앨범명'},
            {value: 'company', label: '회사명'},
            {value: 'album_ref',label: '자사앨범코드'},
            {value: 'barcode',label: 'UPC',},
            {value: 'artist',label: '아티스트명',},
            {value: 'artist_english',label: '아티스트명(영문)',},
            {value: 'name_english',label: '앨범명(번역)',},
        ],

        batchType : 'insert',
        defaultColDef: {
            sortable: false,
            editable: false,
            resizable: true,
            suppressMenu: false,
            rowSelection:'single'
        },
        albumList : {
          keywordType : null,
          keyword : null,
          listData: [],                 
          pageSize: 10,                 
          currentPage: 1,
          totalPage: 0,
          gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
            context: {
                componentParent: this
            },
            frameworkComponents : {
              ...agTableComp
            }
          },
          columnDefs : [
            {headerName: '선택',  field: 'release_date',  filter: false,width: 130,
              cellRendererParams: {
                clicked: function(data) {
                  let insert = { 
                    ...data,
                    ej_action : this.context.componentParent.batchType
                  }
                  const a = this.context.componentParent.selectAlbum.listData
                  const idx = a.findIndex((item) => {return item.id === data.id})
                  this.context.componentParent.selectAlbum.listData.push(insert)
                  this.context.componentParent.addAlbum(insert)
                  this.context.componentParent.albumList.gridOptions.api.setRowData(this.context.componentParent.albumList.listData)
                }
              },
              cellRendererSelector: (data) => {
                const idx = this.selectAlbum.listData.findIndex((item) => {return item.id === data.data.id})
                if(idx<0){
                  return { 
                    component: 'btnSelect',
                    params: {
                      ...data.data,
                    }
                  } 
                }else{
                  
                  return { 
                    component: 'textRender',
                    params: {
                      text : '선택완료',
                      style : `text-align:center; width: 80px;`,
                      ...data.data,
                    }
                  }
                }
              }
            },
            {headerName: '발매일',  field: 'release_date',  filter: false,width: 120,
            cellRenderer: (data) => {
              return this.fixDate(data.value, 'yyyy-MM-dd')
            }},
            {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 120,
            },
            {headerName: '앨범명', field: 'name', filter: false,width: 250,},
            {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
              cellRenderer: (data) => {
                let t = data.value
                let text =  ''
                for ( var i in t ){
                  if(i != 0){
                    text += ', '
                  }
                  text += t[i].display_name
                  
                }
                return text
            }},
            {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
            {headerName: 'Email ID', field: 'licensor.user.email', filter: false,width: 220,},
          ],
        },
        selectAlbum : {
          listData: [],          
          total :0,       
          pageSize: 50,                 
          currentPage: 1,
          totalPage: 0,
          gridOptions :{ // 테이블 옵션 (같은 페이지에 있을때 공유해서 쓰면 에러)
            context: {
                componentParent: this
            },
            frameworkComponents : {
              ...agTableComp
            }
          },
          columnDefs : [
            {headerName: '삭제',  field: 'release_date',  filter: false,width: 130,
              cellRendererParams: {
                clicked: function(data) {
                  // const a = this.context.componentParent.selectAlbum.listData
                  // const b = this.context.componentParent.selectAlbumId[data.ej_action]
                  // const idx = a.findIndex((item) => {return item.id === data.id})
                  // this.context.componentParent.selectAlbum.listData.splice(idx,1)
                  // const idx2 = b.findIndex((item) => {return item === data.id})
                  // this.context.componentParent.selectAlbumId[data.ej_action].splice(idx2,1)
                  this.context.componentParent.deleteAlbum(data);
                }
              },
              cellRendererSelector: (data) => {
                if(this.dataTemplate.state == "temporary"){
                  return { 
                    component: 'btnSelect',
                    params: {
                      ...data.data,
                      title : '삭제',
                      color:'danger'
                    }
                  }
                }else{
                  return { 
                    component: 'textRender',
                    params: {
                      text : '삭제불가',
                      style : 'text-align:center; width: 80px;',
                      ...data.data,
                    }
                  }
                }
                
              }
            },
            
            {headerName: 'Batch ID', field: 'ej_batch_id', filter: false,width: 180,},
            {headerName: 'Batch Action', field: 'ej_action', filter: false,width: 110,cellRenderer: (data) => {
                //      success, error, is_delivering,await_delivery, temporary , is_packaging , await_packaging
                
                let color = {
                    'insert' : '#239351',
                    'update' : '#a412b5',
                    'takedown' : '#f9383f',
                    'await_delivery' : '#a457ad',
                    'temporary' : '#545353',
                    
                    'await_packaging':'#529adb',
                  }
                  
                return `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; color : ${color[data.data.ej_action]}">${data.value}</span></div>`
               }
              
            },
            {headerName: 'Batch 상태',  field: 'ej_state',  filter: false,width: 120,
             cellRendererParams: {
                  clicked: function(data) {
                    if(data.ej_state == 'delivery_failed' || data.ej_state == 'packaging_failed' ){
                      this.context.componentParent.alert({
                          width : 700,
                          msg:`<div style="white-space: pre-wrap; text-align:left;">${data.ej_err_msg} </div>`,
                      });
                    }
                    
                },
            },
            cellRendererSelector: (data) => {
                  let text ={
                      'registered' : '등록',
                      'await_packaging':'패키징 대기',
                      'is_packaging' : '패키징',
                      'packaging_failed' : '패키징실패',
                      'is_delivering' : '전송',
                      'await_delivery' : '전송대기',
                      'delivery_success' : '전송완료',
                      'delivery_failed' : '전송실패',
                  }
                  let color ={
                      'delivery_success' : '#239351',
                      'delivery_failed' : '#f9383f',
                      'is_delivering' : '#a412b5',
                      'await_delivery' : '#a457ad',
                      'registered' : '#545353',
                      'is_packaging' : '#3340ed',
                      'await_packaging':'#529adb',
                      'packaging_failed' : '#f9383f',
                }
                    let t = data.value
                    let dd={
                        component: 'textButton',
                        params: {
                            ...data.data,
                            text: `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; background : ${color[t]}">${text[t]}</span></div>`,
                        }
                    } ;
                    if(!text){
                      dd = {
                        component: 'htmlCustom',
                        params: {
                            ...data.data,
                            text : data.data.ej_err_msg ? String(`${String(data.data.ej_err_msg)}`) : null,
                            html: `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; background : ${color[t]}">${text[t]}</span></div>`,
                        }
                      }
                    }
                    
                    // if(this.selectTrack.track_id ==  data.data.track_id ){
                    //     dd.params['disabled'] = true
                    //     dd.params['title'] = '선택완료'
                    // }
                    
                    return dd
            },
            // cellRenderer: (data) => {
            //     //      success, error, is_delivering,await_delivery, temporary , is_packaging , await_packaging
            //     let text ={
            //         'registered' : '등록',
            //         'await_packaging':'패키징 대기',
            //         'is_packaging' : '패키징',
            //         'packaging_failed' : '패키징실패',
            //         'is_delivering' : '전송',
            //         'await_delivery' : '전송대기',
            //         'delivery_success' : '전송완료',
            //         'delivery_failed' : '전송실패',
            //     }
            //     let color ={
            //         'delivery_success' : '#239351',
            //         'delivery_failed' : '#f9383f',
            //         'is_delivering' : '#a412b5',
            //         'await_delivery' : '#a457ad',
            //         'registered' : '#545353',
            //         'is_packaging' : '#3340ed',
            //         'await_packaging':'#529adb',
            //         'packaging_failed' : '#f9383f',
            //     }
            //     let t = data.value
                
            //     return `<div class="cellCenter"><span class="textCenter" style=" min-width:80px; color:#fff; padding: 3px 8px; border-radius:8px; background : ${color[t]}">${text[t]}</span></div>`
            // }
            },
            {headerName: '발매일',  field: 'release_date',  filter: false,width: 120,
            cellRenderer: (data) => {
              return this.fixDate(data.value, 'yyyy-MM-dd')
            }},
            {headerName: '자사앨범코드', field: 'album_ref', filter: false,width: 120,
             cellRendererParams: {
                  clicked: function(data) {
                      this.context.componentParent.albumViewDetail(data.id);
                  },
              },
              cellRendererSelector: (data) => {
                  let dd={
                    component: 'htmlCustom',
                      params: {
                          ...data.data,
                          text: data.value,
                          html: `<a href='/album/detail/${data.data.id}' target='_blank' style='color: rgba(var(--vs-primary), 1); cursor : pointer' >${data.value}<a/>`
                      }
                  } ;
                  // if(this.selectTrack.track_id ==  data.data.track_id ){
                  //     dd.params['disabled'] = true
                  //     dd.params['title'] = '선택완료'
                  // }
                  
                  return dd
              }
            },
            {headerName: 'YT', field: 'youtube_at', filter: false,width: 100,
             cellRendererParams: {
                  clicked: function(data) {
                  },
              },
              cellRendererSelector: (data) => {
                  let html = ``;
                  if(data.data.youtube_at){
                    html += `
                          <span class="textCenter" style="margin-right:3px; min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #288dda">
                          AT</span>
                    `
                  }else{
                    html += `
                    <span class="textCenter" style="margin-right:3px; min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #838383">AT</span>
                    `
                  }
                  if(data.data.youtube_sr){
                    html += `
                          <span class="textCenter" style=" min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #e1a627">
                            SR
                        </span>
                    `
                  }else{
                    html += `
                          <span class="textCenter" style=" min-width:40px; color:#fff; padding: 3px 5px; border-radius:8px; background : #838383">SR</span>
                    `
                  }
                  let dd={
                        component: 'textButton',
                        params: {
                            ...data.data,
                            text: `
                              ${html}
                            `,
                        }
                    } ;
                  // if(this.selectTrack.track_id ==  data.data.track_id ){
                  //     dd.params['disabled'] = true
                  //     dd.params['title'] = '선택완료'
                  // }
                  
                  return dd
              }
            },
            {headerName: '앨범명', field: 'name', filter: false,width: 250,},
            {headerName: '앨범아티스트명', field: 'artists', filter: false,width: 200,
              cellRenderer: (data) => {
                let t = data.value
                let text =  ''
                for ( var i in t ){
                  if(i != 0){
                    text += ', '
                  }
                  text += t[i].display_name
                  
                }
                return text
            }},
            {headerName: '트랙수', field: 'track_count', filter: false,width: 120,},
            {headerName: '앨범 기획사명', field: 'label', filter: false,width: 220,},
            
          ],
        },

        selectAlbumId :{
          insert : [],
          update : [],
          takedown : [],
        },
        retryAutostart : false,
        pkgFailItems : [],
        dataTemplate: {
            //album_count: 1,
            //albums: [301383],
            created_at: "2022-04-25T04:13:18.511Z",
            del_err_count: null,
            export_contract: {},
            export_contract_id: 4,
            finished_at: null,
            id: 40,
            job_start: null,
            memo: null,
            pkg_err_count: null,
            ref_code: "DJ220425-0004",
            started_at: null,
            state: "temporary",
            success_count: null,
            track_count: 1,
            updated_at: "2022-04-25T04:13:18.511Z",
            insert_count: 0,
            update_count : 0, 
            takedown_count : 0,
 
        },
        jobStateText : {
          'success' : '전송성공',
          'error' : '전송실패',
          'is_delivering' : '전송',
          'await_delivery' : '전송대기',
          'temporary' : '등록',
          'is_packaging' : '패키징',
          'await_packaging':'패키징 대기',
        },
        color:{
            'success' : '#239351',
            'error' : '#f9383f',
            'is_delivering' : '#a412b5',
            'await_delivery' : '#a457ad',
            'temporary' : '#545353',
            'is_packaging' : '#3340ed',
            'await_packaging':'#529adb',
        }
      }
    },
    mounted(){
      this.getContract()
      this.$nextTick(function(){
        this.datacall()
      })
    },
    computed: {
      // Retry resends only the albums that did not fully deliver. A job reaches the
      // 'success' state only once every album is delivered, so anything that is started
      // but not 'success' still has unfinished albums worth retrying.
      canRetry(){
        const state = this.dataTemplate.state
        return !!state && state !== 'temporary' && state !== 'success'
      },
      // Best-effort count of albums that will be carried into the retry job (the backend
      // re-derives the authoritative set from each album's delivery state).
      pendingRetryCount(){
        const total = Number(this.dataTemplate.album_count) || 0
        const done = Number(this.dataTemplate.success_count) || 0
        return Math.max(total - done, 0)
      }
    },
    watch:{
      'albumList.currentPage'(){
        this.albumCall()
      },
      'selectAlbum.currentPage'(){
        this.getAlbum()
      }
     
    },
    methods: {
        datacall(){
            let payload = {
                id : `${this.$route.params.id}`
            }
            this.$store.dispatch('GET_DDEXJOB_DETAIL', payload)
                .then(result =>{
                    let t = result;
                    this.dataTemplate = {...t}
                    this.getAlbum();
                    this.loadingHide();
                }).catch(error=>{
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg:error})
                    break;
                }
            })
           
        },
        getAlbum(){
          let payload = {
              id : `${this.$route.params.id}`,
              params:{
                page: this.selectAlbum.currentPage - 1,
                limit: this.selectAlbum.pageSize,
                sort : 'created_at',
                sortorder: 'asc',
              }
          }
           this.$store.dispatch('GET_DDEXJOB_DETAIL_ALBUM', payload)
              .then(result =>{
                  let t = result.data;
                  console.log(result)
                  this.selectAlbum.listData  = result.items 
                  const remainder = parseInt(result.filtered % this.selectAlbum.pageSize) > 0? 1: 0
                  this.selectAlbum.total = result.filtered
                  this.selectAlbum.totalPage = parseInt(result.filtered /this.selectAlbum.pageSize) + remainder
                  
                  this.loadingHide();
              }).catch(error=>{
              const status = error.status
              switch(status){
                  case 401:
                  this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                  break;
                  default:
                      this.alert({msg:error})
                  break;
              }
          })
        },
        getContract(){
          let payload = {
            sort : 'created_at',
            sortorder: 'desc',
            page: 0 ,
            limit: 50,
          }
            this.$store.dispatch('GET_DDEX_CONTRACT', payload)
            .then(result =>{
                this.loadingHide()
                this.contractList  = result.items // 권리자 목록
                
                //페이지 수
            }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                    this.alert({msg : error.response.data.message})
                    break;
                }
            })
        },
        getAlbumList(){
            this.albumList.currentPage = 1
            this.albumCall()
        },
        albumCall(){
            const payload = {
              sortorder: 'desc',
              page: this.albumList.currentPage - 1,
              limit: 5,
            }
            if(this.albumList.keywordType && this.albumList.keywordType != '') {
            payload[this.albumList.keywordType] = this.albumList.keyword
            }
            this.loadingShow();
            this.$store.dispatch('LIST_ALBUM', payload)
            .then(result =>{
            this.loadingHide();
            this.albumList.listData  = result.items // 권리자 목록
            //페이지 수
            const remainder = parseInt(result.filtered % this.albumList.pageSize) > 0? 1: 0
            this.albumList.totalPage = parseInt(result.filtered /this.albumList.pageSize) + remainder
                
            }).catch(error=>{
                const status = error.response.status
                switch(status){
                case 401:
                this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                break;
                default:
                break;
                }
            })
        },
        addAlbum(data){
          let payload = {
            id : `${this.$route.params.id}`,
            params : {
              insert : [],
              update : [],
              takedown : [],
            }
          }
          payload.params[data.ej_action].push(data.id)
          this.loadingShow()
          this.$store.dispatch('POST_DDEXJOB_DETAIL_ALBUM', payload)
              .then(result =>{
                this.getAlbum()
                this.loadingHide();
              }).catch(error=>{
              const status = error.status
              switch(status){
                  case 401:
                  this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                  break;
                  default:
                      this.alert({msg:error})
                  break;
              }
          })
        }, 
        deleteAlbum(data){
          let payload = {
            id : `${this.$route.params.id}`,
            album_id : data.id,
          }
          this.loadingShow()
          this.$store.dispatch('DELETE_DDEXJOB_DETAIL_ALBUM', payload)
              .then(result =>{

                  this.getAlbum()
                  this.loadingHide();
              }).catch(error=>{
              const status = error.status
              switch(status){
                  case 401:
                  this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                  break;
                  default:
                      this.alert({msg:error})
                  break;
              }
          })
        },
        startDDEX(){
          let payload = {
            id : `${this.$route.params.id}`,
            
          }
          this.loadingShow()
          this.$store.dispatch('START_DDEX', payload)
              .then(result =>{
                this.noti('시작요청이 완료되었습니다.')
                this.datacall()
              }).catch(error=>{
              const status = error.status
              switch(status){
                  case 401:
                  this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                  break;
                  default:
                      this.alert({msg:error})
                  break;
              }
          })
        },
        openPkgFailModal() {
          this.pkgFailItems = this.selectAlbum.listData.filter(a => a.ej_state === 'packaging_failed')
          this.openModal('pkgFailDetail')
        },
        openRetryModal(){
          this.retryAutostart = false
          this.openModal('retryDDEX')
        },
        confirmRetry(){
          let payload = {
            id : `${this.$route.params.id}`,
            params : {
              autostart : this.retryAutostart,
            }
          }
          this.loadingShow()
          this.$store.dispatch('RETRY_DDEX', payload)
              .then(result =>{
                this.loadingHide()
                this.closeModal('retryDDEX')
                this.noti('재시도 작업이 생성되었습니다.')
                this.$router.push('/ddex/job/detail/' + result.id).catch(()=>{})
                this.$nextTick(()=>{ this.datacall() })
              }).catch(error=>{
                this.loadingHide()
                const status = error.status
                switch(status){
                    case 401:
                    this.$store.dispatch('TOKEN_ITEM_CLEAR').then(()=>{this.$router.push('/login')})
                    break;
                    default:
                        this.alert({msg: error?.response?.data?.message || '재시도 작업 생성에 실패했습니다.'})
                    break;
                }
          })
        },
        saveMemo(data){
          let payload = {
            id : `${this.$route.params.id}`,
            params : {
              memo : this.dataTemplate.memo
            }
          }
          this.loadingShow();
          this.$store.dispatch("PUT_DDEXJOB", payload)
          .then(result =>{
          this.loadingHide();
          this.noti('메모가 저장되었습니다.')
          }).catch(error =>{
          this.loadingHide();
          switch(error.response.data.code) {
              default:
              this.alert({
                  msg: error.response.data.message,
              })
              break;
          }
          })
        },
        albumViewDetail(id){
          let url = '/album/detail/' +id
          window.open(url);
        },
    },

}
</script>

<style scoped>

</style>